module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-form-fieldset', {
    attrs: {
      "label": "from a list of"
    }
  }, [_c('div', {
    staticClass: "row",
    class: _vm.className
  }, [_c('div', {
    staticClass: "col"
  }, [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("PLU")]), _vm._v(" "), _c('th', [_vm._v("Product")]), _vm._v(" "), (_vm.enableSubsidy) ? _c('th', [_vm._v("Regular price")]) : _vm._e(), _vm._v(" "), (_vm.enableSubsidy) ? _c('th', [_vm._v("Sales price")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_c('b-button', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v("\n              Add\n            ")])], 1)])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.value), function(product, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(product.plu))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(product.name))]), _vm._v(" "), (_vm.enableSubsidy) ? _c('td', [_vm._v(_vm._s(_vm.getBasePrice(product)))]) : _vm._e(), _vm._v(" "), (_vm.enableSubsidy) ? _c('td', [_vm._v(_vm._s(_vm._f("rounded")(_vm.getDiscountedPrice(product))))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_c('b-button', {
      staticClass: "delete",
      attrs: {
        "variant": "secondary"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.remove(product)
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "close"
      }
    })], 1)], 1)])
  }), _vm._v(" "), (_vm.value.length === 0) ? _c('tr', {
    class: {
      'has-danger': !_vm.validator.required
    }
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("Please add products")])]) : _vm._e()], 2)]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validator.required),
      expression: "!validator.required"
    }],
    staticClass: "BuyXFroDiscountPartialView__error"
  }, [_vm._v("\n        Required\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-cb1e0af4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/EditEvent/AddPromotion/ProductList.vue
// module id = 1707
// module chunks = 1